import { render, staticRenderFns } from "./NewProductConfiguratorEditorColor.vue?vue&type=template&id=85c7e93e&"
import script from "./NewProductConfiguratorEditorColor.vue?vue&type=script&lang=js&"
export * from "./NewProductConfiguratorEditorColor.vue?vue&type=script&lang=js&"
import style0 from "./NewProductConfiguratorEditorColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports